module.exports = __webpack_public_path__ + "media/images/extincteurs-dcaceda4562781ad0d72ba2abbaee60c.svg";